import { useConfig } from '@hooks/useConfig';
import { useQuery } from '@tanstack/react-query';
import { axios } from 'lib';
import { toast } from 'react-toastify';

export const useStudentsData = () => {
  const config = useConfig();
  const fetchStudentsList = async () => {
    try {
      const response = await axios.get('/admin-dashboard/all-students', config);
      return response.data.students;
    } catch (error) {
      throw error;
    }
  };

  const { data: studentsList, isFetching: loadingStudentsList } = useQuery({
    queryKey: ['student-list'],
    queryFn: fetchStudentsList,
    onError: (err) =>
      toast.error(
        typeof err === 'string'
          ? err
          : 'Something went wrong fetching status list'
      ),
  });

  return [{ studentsList, loadingStudentsList }];
};

export const useStudentsDetail = (id: any) => {
  const config = useConfig();
  const fetchStudentsDetail = async (id: any) => {
    try {
      const response = await axios.get(`/student/show/${id}`, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const { data: studentsList, isFetching: loadingStudentsList } = useQuery({
    queryKey: ['student-detail', id],
    queryFn: () => fetchStudentsDetail(id),
    onError: (err) =>
      toast.error(
        typeof err === 'string'
          ? err
          : 'Something went wrong fetching status list'
      ),
  });

  return [{ studentsList, loadingStudentsList }];
};
